// extracted by mini-css-extract-plugin
module.exports = {"wrap":"SmallBanner-module--wrap--2-xfM"};